import script from "./SourcesDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SourcesDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SourcesDropdown.vue?vue&type=style&index=0&id=317f488b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-317f488b"]])

export default __exports__